export default function EventInfoDates({ dates }) {
  return (
    <div className="flex flex-col">
      {dates.map(({ date, hour }, index) => (
        <div
          key={`event-date-${index}`}
          className=" flex items-center space-x-4"
        >
          <div className="font-medium">{date}</div>
          <div className="flex-1 border-t-2 border-dashed border-gray-700" />
          <div className="font-normal">{hour}</div>
        </div>
      ))}
    </div>
  );
}
